import { ApplicationBrick, ApplicationLicense } from './ApplicationBrick'

import InstallLicenseTools from '../../pages/InstallLicenseTools'
import InstallEngine from '../../pages/InstallEngine'
import RetrieveLocalLicense from '../../pages/RetrieveLocalLicense'

import { getNonLocalLicenses } from '../../pages/client/shared/licenses'
import DockerStartApplication from '../../pages/client/shared/DockerStartApplication'

import InstallGurobiPyPi from '../../pages/client/python/InstallPackagesPip'
import InstallGurobipyConda from '../../pages/client/python/InstallPackagesConda'
import InstallGurobipyWheel from '../../pages/client/python/InstallPackagesWheel'
import ClientPythonDocker from '../../pages/client/python/ClientPythonDocker'
import ClientPythonApplication from '../../pages/client/python/ClientPythonApplication'
import TricksPyomo from '../../pages/client/python/TricksPyomo'
import TricksORTools from '../../pages/client/python/TricksORTools'
import TricksPuLP from '../../pages/client/python/TricksPuLP'
import TricksCVXPY from '../../pages/client/python/TricksCVXPY'
import TricksGurobipy from '../../pages/client/python/TricksGurobipy'
import { createDescriptor, PageDescriptor } from '../../pages/types'

export class PythonApplicationBrick extends ApplicationBrick {
    constructor(license: ApplicationLicense, readonly os: string, framework: string, packageManager: string, isContainer: boolean, isOrchestrated: boolean) {
        super(license, 'python', framework, packageManager, isContainer, isOrchestrated)
    }

    public key(): string { 
        return 'app-python'
    }

    *getPages(): Generator<PageDescriptor> {
        const { framework, os, packageManager, license } = this
        if(this.requireLicenseTools()) {
            yield createDescriptor(InstallLicenseTools, { os })
        }
        if(this.requiresFullInstallation()) {
            yield createDescriptor(InstallEngine, { os })
        }
        if(!this.isContainer()) {
            if((packageManager == 'pip' || (packageManager == '' && framework != ''))) {
                yield createDescriptor(InstallGurobiPyPi, { framework, isLocalLicense: this.isLocalLicense(), requiresGurobipy: !this.frameworkRequiresFullInstallation() })
            }
            if(packageManager == 'anaconda') {
                yield createDescriptor(InstallGurobipyConda, { framework, isLocalLicense: this.isLocalLicense() })
            }
            if(packageManager == '' && framework == '') {
                yield createDescriptor(InstallGurobipyWheel, {})
            }
        } 
        if(this.isLocalLicense()) {
            yield createDescriptor(RetrieveLocalLicense, {})
        } else {
            yield *getNonLocalLicenses(license, this.isContainer(), os )
        }
        if(this.isContainer()) {
            yield createDescriptor(ClientPythonDocker, { packageManager, framework, requiresFullInstallation: this.frameworkRequiresFullInstallation() })
        }
        if(license !== null)
        {
            yield createDescriptor(ClientPythonApplication, { framework, license, needsLicenseFile: this.requireLicenseFile() })
        }
        switch(framework)
        {
            case 'pyomo':
                yield createDescriptor(TricksPyomo, {})
                break
            case 'pulp':
                yield createDescriptor(TricksPuLP, { license })
                break
            case 'ortools':
                yield createDescriptor(TricksORTools, {})
                break
            case 'cvxpy':
                yield createDescriptor(TricksCVXPY, {})
                break
            default:
                yield createDescriptor(TricksGurobipy, {})
                break
        }
        if(this.isContainer() && !this.isOrchestrated()) {
            yield createDescriptor(DockerStartApplication, { hasLicenseFile: this.requireLicenseFile() })
        }        
    }

    packageManagerContainsLicenseTools(): boolean {
        return this.packageManager == 'anaconda'
    }

    frameworkRequiresFullInstallation(): boolean {
        return this.framework == 'ortools'
    }

    // For Python, we suggest downloading the wheel file so no full installation required
    installWithoutPackageManagerRequiresFullInstallation(): boolean {
        return false
    }

}